angular
  .module('VSPApp')
  .controller('MeineakteVersicherungenController', [function() {}]);
